const API_BASE = process.env.REACT_APP_API_URL || 'https://sukhsagarapi.artifycode.com/api';
// const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
async function request(path, options = {}) {
  const url = `${API_BASE}${path}`;
  try {
    const res = await fetch(url, {
      headers: { 'Content-Type': 'application/json' },
      mode: 'cors',
      ...options,
    });
    
    if (!res.ok) {
      try {
        const err = await res.json();
        const error = new Error(err.message || `HTTP Error ${res.status}`);
        error.status = res.status;
        throw error;
      } catch (parseErr) {
        const error = new Error(`HTTP Error ${res.status}: ${res.statusText}`);
        error.status = res.status;
        throw error;
      }
    }
    
    if (res.status === 204) return null;
    return res.json();
  } catch (err) {
    // Better error logging for debugging
    console.error(`API Error - ${options.method || 'GET'} ${url}:`, err.message);
    if (err.message && err.message.includes('Failed to fetch')) {
      console.error('This may be a CORS issue. Ensure the server allows requests from:', window.location.origin);
    }
    throw err;
  }
}

export const api = {
  get: (path) => request(path, { method: 'GET' }),
  post: (path, body) => request(path, { method: 'POST', body: JSON.stringify(body) }),
  put: (path, body) => request(path, { method: 'PUT', body: JSON.stringify(body) }),
  delete: (path) => request(path, { method: 'DELETE' }),
};
